var classes = {"container":"CardImage-module_container__HxAgU","small":"CardImage-module_small__1NMzM","placeholder":"CardImage-module_placeholder__OQZ2t","large":"CardImage-module_large__Vv-VS","photo-container":"CardImage-module_photo-container__RYspN","photo":"CardImage-module_photo__WMsiO","count":"CardImage-module_count__HEjKn"};

export { classes as default };
//# sourceMappingURL=CardImage.module.scss.js.map
